import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeModule } from '@ex/module/shared/Theme/theme.module';
import { AirLaunchAnnouncementComponent } from './ui/air-launch-announcement/air-launch-announcement.component';
import { RebrandAnnouncementComponent } from './ui/rebrand-announcement/rebrand-announcement.component';
import { CultureLaunchAnnouncementsComponent } from './ui/culture-launch-announcements/culture-launch-announcements.component';

// Home for every announcement modal. ThemeModule alone supplies z-modal, zenButton
// and the translate pipe — SharedModule is deliberately not imported.
@NgModule({
  declarations: [
    AirLaunchAnnouncementComponent,
    RebrandAnnouncementComponent,
    CultureLaunchAnnouncementsComponent,
  ],
  imports: [
    CommonModule,
    ThemeModule,
  ],
  exports: [
    AirLaunchAnnouncementComponent,
    RebrandAnnouncementComponent,
  ],
})
export class AnnouncementsModule { }
